import { useContext } from 'react';
import { PaginationFilterContext } from '../helpers/context';
import { PaginationHook } from '../types';

export const usePaginationFilter = (): PaginationHook | undefined => {
	return useContext(PaginationFilterContext);
};
